// content-card
import { Card } from 'antd';

export default function TokenCardMedium(props) {
  
  const data = props.data;

  return (
    <>
      <div className="" >

        <Card
          hoverable
          className="rounded-wd"
          bodyStyle={{margin:'0rem', padding:'0rem'}}
          cover={
            <div className="media-square rounded-none" 
              style={{borderBottomLeftRadius:0, borderBottomRightRadius:0}}>
              <img className="" src={data.link} alt={data.memo}></img>
            </div>
          }
        >

        </Card>

      </div>
  
    </>
    )
  }